import { connect } from 'react-redux'
import CadastroContratoModal from './modal';

export default connect()(CadastroContratoModal);
